import {
  CalculationState,
  initialCalculationState,
  initialConfiguration,
  Configuration,
  BudgetCalculationState,
  initialBudgetCalculationState,
} from "./sections";

type AppState = {
  configuration: Configuration;
  calculation: CalculationState;
  budgetCalculation: BudgetCalculationState;
};

const initialAppState: AppState = {
  configuration: initialConfiguration,
  calculation: initialCalculationState,
  budgetCalculation: initialBudgetCalculationState,
};

export { type AppState, initialAppState };
